/**
 * Queries para obtener información de egresos de tesorería
 */

export const GET_EGRESO_DETALLE_CONSTANCIA = `
  query getEgresoDetalleConstancia($id: String!) {
    getEgresoDetalleConstancia(id: $id) {
      id
      tipoOrden
      
      proveedor {
        nombreProveedor
        contactos {
            correo
        }
      }
      
      cuenta {
        tipo
      }
      
      egresos {
        file
        codigo
        monto
        observaciones
        email
        codigoReserva
      }
      
      proofsOfPayment {
        id
        isProofOfPayment
        mailSent
        uploadedBy
        mailSentBy
        mailSentByEmail
        mailSentAt
        toEmails
        isDeleted
      }
    }
  }
`;

export const GET_EGRESO_DETALLE = `
  query getEgreso($id: String!){
        getEgreso(id:$id){
          updatedAt,
          fechaReprogramacion,
          id,
          hasUnresolvedOrderReferences,
          unresolvedOrderIds,
          comision,
          fechaPago,
          estado,
          tipoOrden,
          egresos{
            orderReferenceStatus,
            proveedorName,
            file,
            fileExtend,
            codigo,
            monto,
            id,
            observaciones,
            nameClient,
            tipoEgreso,
            categoriaEgreso

          }
          cuenta{
             id,
             nombre,
             tipo,
             descripcion,
             saldo
           }
          cargadoTelecredito,
          proveedor{
            id,
            nombreProveedor
          }
        }
      }
`;

/**
 * Query liviana para obtener solo metadata de comprobantes enviados en un egreso
 */
export const GET_EGRESO_PROOFS_OF_PAYMENT = `
  query getEgresoDetalleConstancia($id: String!) {
    getEgresoDetalleConstancia(id: $id) {
      proofsOfPayment {
        id
        mailSent
        mailSentBy
        mailSentByEmail
        mailSentAt
        isDeleted
      }
    }
  }
`;

/** Selección exclusiva de Control Diario; conserva los campos de sus filtros. */
export const GET_CONTROL_DIARIO_EGRESOS_PAGE = `
  query getControlDiarioEgresosPage($limit: Float, $nextToken: String) {
    getAllEgresosTesoreriaSummaryPaginated(limit: $limit, nextToken: $nextToken) {
      items {
        id
        comision
        fechaPago
        estado
        tipoOrden
        cargadoTelecredito
        egresos {
          id
          monto
          observaciones
        }
        egresosSAF { id monto moneda observaciones }
        proveedor { nombreProveedor }
        cuenta { id nombre tipo descripcion }
      }
      nextToken
      hasMore
    }
  }
`;

export const GET_EGRESO_ORDER_DETAILS = `
  query getEgresoOrderDetails($id: String!) {
    getEgresoOrderDetails(id: $id) {
      id
      tipoOrden
      hasUnresolvedOrderReferences
      unresolvedOrderIds
      egresos {
        id orderReferenceStatus file fileExtend codigo monto observaciones
        tipoEgreso categoriaEgreso nameClient usuario email codigoReserva proveedorName
      }
      egresosSAF { id orderReferenceStatus codigo file monto moneda }
    }
  }
`;

/**
 * Query paginada para obtener todos los egresos de tesorería
 * Soporta paginación con nextToken para obtener grandes cantidades de datos
 */
export const GET_ALL_EGRESOS_TESORERIA_PAGINATED = `
  query getAllEgresosTesoreriaPaginated($limit: Float, $nextToken: String, $cuentaBancoId: String) {
    getAllEgresosTesoreriaPaginated(limit: $limit, nextToken: $nextToken, cuentaBancoId: $cuentaBancoId) {
      items {
        hasUnresolvedOrderReferences
        unresolvedOrderIds
        updatedAt
        fechaReprogramacion
        id
        comision
        fechaPago
        estado
        tipoOrden
        tipoPayment
        cargadoTelecredito
        
        egresos {
          orderReferenceStatus
          proveedorName
          file
          fileExtend
          codigo
          monto
          id
          observaciones
          tipoEgreso
          categoriaEgreso
          nameClient
          usuario
          codigoReserva
        }
        
        egresosSAF {
          id
          orderReferenceStatus
          monto
          moneda
        }
        
        proveedor {
          id
          nombreProveedor
        }
        
        cuenta {
          id
          nombre
          tipo
          descripcion
          saldo
        }
      }
      nextToken
      hasMore
    }
  }
`;

/**
 * Candidatos para el flujo de Vincular Pago. La cuenta bancaria es obligatoria
 * para evitar cargar egresos de otras cuentas en el modal.
 */
export const GET_EGRESOS_DISPONIBLES_PARA_VINCULACION = `
  query getEgresosDisponiblesParaVinculacion($cuentaBancoId: String!, $limit: Float, $nextToken: String) {
    getEgresosDisponiblesParaVinculacion(cuentaBancoId: $cuentaBancoId, limit: $limit, nextToken: $nextToken) {
      items {
        hasUnresolvedOrderReferences
        unresolvedOrderIds
        updatedAt
        fechaReprogramacion
        id
        comision
        fechaPago
        estado
        tipoOrden
        tipoPayment
        cargadoTelecredito
        egresos {
          orderReferenceStatus
          proveedorName
          file
          fileExtend
          codigo
          monto
          id
          observaciones
          tipoEgreso
          categoriaEgreso
          nameClient
          usuario
          codigoReserva
        }
        egresosSAF {
          id
          orderReferenceStatus
          monto
          moneda
        }
        proveedor {
          id
          nombreProveedor
        }
        cuenta {
          id
          nombre
          tipo
          descripcion
          saldo
        }
      }
      nextToken
      hasMore
    }
  }
`;

export const GET_INCOME_RECONCILIATION_PAYMENT_CANDIDATES = `
  query getIncomeReconciliationPaymentCandidates($cuentaBancoId: String!, $limit: Float, $nextToken: String) {
    getIncomeReconciliationPaymentCandidates(cuentaBancoId: $cuentaBancoId, limit: $limit, nextToken: $nextToken) {
      items {
        hasUnresolvedOrderReferences
        unresolvedOrderIds
        id
        comision
        fechaPago
        estado
        tipoOrden
        cargadoTelecredito
        egresos {
          file
          fileExtend
          codigo
          monto
          observaciones
        }
        egresosSAF {
          monto
        }
        proveedor {
          nombreProveedor
        }
        cuenta {
          nombre
          tipo
        }
      }
      nextToken
      hasMore
    }
  }
`;

/**
 * Query para obtener todas las cuentas bancarias
 */
/**
 * Mutation para actualizar un egreso
 */
export const UPDATE_EGRESO = `
  mutation updateEgreso($id: String!, $egreso: input_egresoModel!) {
    updateEgreso(id: $id, egreso: $egreso) {
      id
    }
  }
`;

export const CHANGE_EGRESO_BANK_ACCOUNT = `
  mutation changeEgresoBankAccount($input: ChangeEgresoBankAccountInput!) {
    changeEgresoBankAccount(input: $input) {
      id
      updatedAt
      cuenta {
        id
        nombre
        tipo
        descripcion
      }
    }
  }
`;

/**
 * Mutation para eliminar un egreso
 */
export const DELETE_EGRESO = `
  mutation deleteEgreso($id: String!) {
    deleteEgreso(id: $id) {
      id
    }
  }
`;

/**
 * Mutation para crear un egreso
 */
export const CREATE_EGRESO = `
  mutation createEgreso($egreso: input_egresoModel!) {
    createEgreso(egreso: $egreso) {
          id,
          fechaReprogramacion,
          comision,
          fechaPago,
          estado,
          tipoOrden,
          updatedAt,
          egresos{
            proveedorName,
            file,
            codigo,
            monto,
            id,
            observaciones,
            nameClient,
            tipoEgreso,
            categoriaEgreso
          }
          cuenta{
            id,
            nombre,
            tipo,
            descripcion,
            saldo
          }
          cargadoTelecredito,
          proveedor{
            id,
            nombreProveedor
          }
    }
  }
`;
